import { useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { MobileCTA } from "@/components/site/MobileCTA";
import Home from "@/pages/Home";
import Casa from "@/pages/Casa";
import Camere from "@/pages/Camere";
import GalleryPage from "@/pages/GalleryPage";
import DoveSiamo from "@/pages/DoveSiamo";
import CosaVedere from "@/pages/CosaVedere";
import Esperienze from "@/pages/Esperienze";
import Recensioni from "@/pages/Recensioni";
import Contatti from "@/pages/Contatti";
import Prenota from "@/pages/Prenota";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const LenisScroll = () => {
  const lenisRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <LenisScroll />
        <ScrollToTop />
        <div className="App min-h-screen bg-sand pb-[72px] md:pb-0">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/la-casa" element={<Casa />} />
              <Route path="/camere" element={<Camere />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/dove-siamo" element={<DoveSiamo />} />
              <Route path="/cosa-vedere" element={<CosaVedere />} />
              <Route path="/esperienze" element={<Esperienze />} />
              <Route path="/recensioni" element={<Recensioni />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/prenota" element={<Prenota />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <MobileCTA />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
